import { curriculumForGrade } from "@/data/curriculum";

export interface StudentLevelProfile {
  grade: string | null;
  title: string;
  description: string;
  dailyMinutes: number;
  focusMinutes: number;
  questionCount: number;
  curriculumCount: number;
  needsSchoolTrack: boolean;
}

export function studentLevelProfile(grade: string | null): StudentLevelProfile {
  const level = Number(grade);
  const curriculumCount = curriculumForGrade(grade).length;
  if (level >= 1 && level <= 4) {
    return {
      grade,
      title: `${level}. sınıf başlangıç profili`,
      description: "Kısa, düzenli tekrar ve temel beceri odaklı çalışma düzeni.",
      dailyMinutes: 40,
      focusMinutes: 20,
      questionCount: 10,
      curriculumCount,
      needsSchoolTrack: false,
    };
  }
  if (level >= 5 && level <= 8) {
    return {
      grade,
      title: `${level}. sınıf gelişim profili`,
      description: "Konu öğrenme, soru çözümü ve eksik konu tekrarını dengeler.",
      dailyMinutes: 60,
      focusMinutes: 25,
      questionCount: 15,
      curriculumCount,
      needsSchoolTrack: false,
    };
  }
  if (level >= 9 && level <= 12) {
    return {
      grade,
      title: `${level}. sınıf planlama profili`,
      description: "Ders kapsamı okul türü ve alan seçimine göre tamamlanır; mevcut performans verileriyle kişiselleştirilir.",
      dailyMinutes: 90,
      focusMinutes: 30,
      questionCount: 20,
      curriculumCount,
      needsSchoolTrack: true,
    };
  }
  return {
    grade,
    title: "Başlangıç profili",
    description: "Sınıf seviyeni tamamladığında ders kapsamın ve çalışma rotan otomatik hazırlanır.",
    dailyMinutes: 40,
    focusMinutes: 20,
    questionCount: 10,
    curriculumCount,
    needsSchoolTrack: false,
  };
}
